<div [ngClass]="disabled ? 'disabled square' : 'square'" (click)="onClick($event)">
  <div class="content">
    <ng-content select=".icon"></ng-content>
    <ng-content select=".text"></ng-content>
  </div>
</div>
